import { render, staticRenderFns } from "./appIndex.vue?vue&type=template&id=537f4285&scoped=true&"
import script from "./appIndex.vue?vue&type=script&lang=js&"
export * from "./appIndex.vue?vue&type=script&lang=js&"
import style0 from "./appIndex.vue?vue&type=style&index=0&id=537f4285&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f4285",
  null
  
)

export default component.exports